import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4973916e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "book-history-table-container" }
const _hoisted_2 = { class: "filter" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "opacity-area" }, null, -1 /* HOISTED */))
const _hoisted_4 = {
  key: 2,
  class: "no-data-wrapper"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "no-data-title" }, "예약 내역이 없습니다.", -1 /* HOISTED */))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "no-data-description" }, "간편하게 통근버스를 예약해보세요!", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.shouldShowFilterMenu)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "filter-wrapper",
          onClick: $setup.emitOnClickFilter
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("p", null, _toDisplayString($props.filterDisplayText), 1 /* TEXT */),
            _createVNode($setup["InlineSvg"], {
              src: require('@/assets/icons/chevron-down.svg'),
              alt: ""
            }, null, 8 /* PROPS */, ["src"])
          ]),
          _hoisted_3
        ]))
      : _createCommentVNode("v-if", true),
    ($props.bookInfos.length)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          ref: "bookHistoryContentRef",
          class: _normalizeClass(["book-history-content-area", { 'with-filter': $props.shouldShowFilterMenu }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.bookInfos, (bookInfo) => {
            return (_openBlock(), _createElementBlock("div", {
              key: bookInfo.bookDetailId,
              class: "book-history-row-wrapper"
            }, [
              _createVNode($setup["BookHistoryRow"], {
                class: "book-history-row",
                bookInfo: bookInfo,
                onClick: ($event: any) => ($setup.getBookInfoDetail(bookInfo))
              }, null, 8 /* PROPS */, ["bookInfo", "onClick"])
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ], 2 /* CLASS */))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("button", {
            class: "line-search-btn",
            onClick: $setup.goToLineSearch
          }, " 노선 검색하기 ")
        ])),
    ($setup.bookHistoryContentRef)
      ? (_openBlock(), _createBlock($setup["ScrollTopControl"], {
          key: 3,
          container: $setup.bookHistoryContentRef
        }, null, 8 /* PROPS */, ["container"]))
      : _createCommentVNode("v-if", true)
  ]))
}